export default "__VITE_ASSET__CEZIHk8S__"